import { render, staticRenderFns } from "./PeriodRequiredDialog.vue?vue&type=template&id=64ad2720"
import script from "./PeriodRequiredDialog.vue?vue&type=script&lang=js"
export * from "./PeriodRequiredDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports